import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

// Solid black fallback so chunk loads between routes never flash white.
// Per-route Suspense keeps AppLayout (nav + banner) mounted while the
// next page's lazy chunk resolves.
function RouteFallback() {
  return <div style={{ background: 'var(--pc-app-bg)', minHeight: '100vh' }} />;
}

export function PageTransition() {
  return (
    <div className="h-full min-h-0">
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
    </div>
  );
}
